import type { Locale } from "@/lib/i18n";
import { pl, type OAuthButtonsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const oauthButtonsTranslations: Record<Locale, OAuthButtonsTranslations> = {
  pl,
  en,
  de,
};

export type { OAuthButtonsTranslations };
